import React from 'react';

const ArrowRight = props => (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.width || '9'} height={props.height || '15'} style={props.style} viewBox="0 0 9 15">
        <g fill="none" fillRule="evenodd">
            <g fill={props.color ? props.color : '#3C3C3B'}>
                <path d="M.45 2.685L5.234 7.5.456 12.315c-.608.628-.608 1.595 0 2.223.283.294.683.462 1.103.462.42 0 .82-.168 1.103-.462l5.88-5.927c.61-.626.61-1.594 0-2.22L2.662.462C2.378.168 1.978 0 1.559 0c-.42 0-.82.168-1.103.462C.16.763-.002 1.16 0 1.571c-.003.412.157.81.45 1.114z" transform="translate(-486 -183) translate(486 183)" />
            </g>
        </g>
    </svg>
);

export default ArrowRight;